module.exports = __webpack_public_path__ + "img/dick-perez.6bc3ffa5.jpg";